module.exports = __webpack_public_path__ + "static/media/reporte2012.18b38085.png";